import React, { useEffect, useMemo, useState } from 'react';
import { Collapse, Icon, Tooltip, Modal } from 'antd';
import { Button, notification, Table, Widget } from '@digital/ui';
const { Panel } = Collapse;
import { getAll, BidCycleItem, excluir, getBidPendencias, BidCyclePendencias } from '@app/api/bidCycle';
import { currencyFormat } from '@app/helpers/numbers';
import ModalUpdateItem from './ModalUpdateItem';
import { TipoDemanda } from '@app/api/demanda';
import './custom.css';
import { FluxoProcesso, FluxoProcessoOptions, getAllFluxoProcessoEtapa } from '@app/api/FluxoProcesso';

const Parametros = () => {
  const [update, setUpdate] = useState(false);
  const [data, setData] = useState<BidCycleItem[]>();
  const [item, setItem] = useState<BidCycleItem | null>(null);
  const [idPai, setIdPai] = useState<string | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [fluxoProcessoOptions, setFluxoProcessoOptions] = useState<FluxoProcessoOptions[] | undefined>();
  const [bidCyclePendencias,setBidCyclePendencias] = useState<BidCyclePendencias[]>();

  const onUpdate = () => {
    setUpdate(!update);
    setItem(null);
  };

  const onExcluir = (id: string) => {
    excluir(id).then(data => {
      if (data.valid) {
        onUpdate();
      }
    });
  };

  const verificaPendencia = () => {
    getBidPendencias().then((data: BidCyclePendencias[] | undefined)=>{
      if(data != undefined){
        setBidCyclePendencias(data);
      }
    })
  }

  const verificaErro = (id: string) => {
    if (
      bidCyclePendencias != null && (bidCyclePendencias.map(c => c.bidCyclePaiId).indexOf(id)>0)
    ) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(()=>{
    setUpdate(!update);
  },[bidCyclePendencias])

  const columns = useMemo(() => {
    const columns = ([] = new Array());

    columns.push({
      title: 'Item',
      dataIndex: 'itemTexto',
      key: 'itemTexto',
      width: '8%',
    });

    columns.push({
      title: 'Processo',
      dataIndex: 'tipo',
      render: (text, record) => (record.itemPaiId ? record.descricao : TipoDemanda[record.tipo]),
      width: '10%',
    });

    columns.push({
      title: 'Valor de',
      dataIndex: 'valorDe',
      render: (text, record) => currencyFormat(record.valorDe),
      width: '10%',
    });

    columns.push({
      title: 'Valor até',
      dataIndex: 'valorAte',
      render: (text, record) => (record.itemPaiId ? '' : currencyFormat(record.valorAte)),
      width: '10%',
    });

    columns.push({
      title: 'Mínimo de Proponentes',
      dataIndex: 'minimoProponentes',
      render: (text, record) => (record.itemPaiId ? '' : record.minimoProponentes),
      width: '5%',
    });

    columns.push({
      title: 'Análise Financeira?',
      dataIndex: 'analiseFinanceira',
      render: (text, record) => (record.itemPaiId ? '' : record.analiseFinanceira ? 'Sim' : 'Não'),
      width: '5%',
    });

    columns.push({
      title: 'Análise Compliance?',
      dataIndex: 'analiseCompliance',
      render: (text, record) => (record.itemPaiId ? '' : record.analiseCompliance ? 'Sim' : 'Não'),
      width: '5%',
    });

    columns.push({
      title: 'Direcionamento Fornecedor',
      dataIndex: 'diasDirecionamentoFornecedor',
      render: (text, record) => record.diasDirecionamentoFornecedor,
      width: '5%',
    });

    columns.push({
      title: 'Visita Técnica',
      dataIndex: 'visitaTecnica',
      render: (text, record) => record.visitaTecnica,
      width: '5%',
    });

    columns.push({
      title: 'Duração Total',
      dataIndex: 'duracaoTotal',
      render: (text, record) => record.duracaoTotal,
      width: '5%',
    });

    columns.push({
      title: 'Ações',
      dataIndex: 'actions',
      render: (text, record ) => {
        return (
          <>
          {!record.itemPaiId && verificaErro(record.id) ? (
              <>
                <Tooltip title={`Pendências`}>
                  <Button
                    icon="ui-info"
                    className="exclamationIcon"
                    onClick={() => {
                      if(bidCyclePendencias != null){
                        let aux = bidCyclePendencias[bidCyclePendencias.map(c=>c.bidCyclePaiId).indexOf(record.id)];
                        let listBid:any = [];
                        let listFluxo:any = [];

                        aux.pendencias.forEach(c=>{
                          if(c.includes("1)")){
                            listBid.push(c.replace("1)",''));
                          }else{
                            listFluxo.push(c.replace("2)",''));
                          }
                        });

                        Modal.warn({
                          title: 'Pendências',
                          content: 
                          <>
                            {listBid.length > 0 && <h3><b>{"O(s) seguinte(s) iten(s) do Bid Cycle não possuem uma etapa do Fluxo de Processo vinculada:"}</b></h3>}
                            <ul>
                              {
                                listBid.map((item:any)=>{
                                    return <li><b>{item}</b></li>;
                                })
                              }
                            </ul>
                            {listFluxo.length > 0 && <h3><b>{"A(s) seguinte(s) etapa(s) não foram vinculadas a nenhuma etapa do Bid Cycle:"}</b></h3>}
                            <ul>
                              {
                                listFluxo.map((item:any)=>{
                                    return <li><b>{item}</b></li>;
                                })
                              }
                            </ul>
                          </>,
                          okText: 'Fechar',
                          onOk: () => {
                          },
                        });
                      }
                    }}
                  />
                </Tooltip>
              </>
            ) : (<></>)}
            <Tooltip title="Editar">
              <Button
                icon="commons-edit"
                onClick={() => {
                  setShowModal(true);
                  setItem(record);
                  setIdPai(record.itemPaiId);
                }}
              />
            </Tooltip>
            {!record.itemPaiId ? (
              <>
                <Tooltip title="Adicionar Subitem">
                  <Button
                    icon="commons-plus"
                    onClick={() => {
                      setShowModal(true);
                      setItem(null);
                      setIdPai(record.id);
                    }}
                  />
                </Tooltip>
              </>
            ) : (
              <></>
            )}
            <Tooltip title="Excluir">
              <Button icon="science-minus" onClick={() => onExcluir(record.id)} />
            </Tooltip>
          </>
        );
      },
      width: '5%',
    });

    return columns;
  }, [data]);

  useEffect(() => {
    getAll().then(data => setData(data));
  }, [update]);

  useEffect(()=>{
    getAllFluxoProcessoEtapa().then((data:FluxoProcesso[] | undefined) => {
      if(data != undefined){
        setFluxoProcessoOptions(
          data.map(a => ({ text: a.descricaoEtapa, value: a.id.toString() }))
        );
      }
    });
  },[])

  return (
    <Collapse activeKey={['parametros']} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
      <Panel key="parametros" header="Parâmetros do Bid Cycle">
        <Widget
          actions={[
            true && (
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    setShowModal(true);
                    setIdPai(null);
                    setItem(null);
                  }}>
                  INCLUIR ITEM
                </Button>
                <Button
                  style={{marginRight: 5}}
                  type="primary"
                  onClick={verificaPendencia}
                >
                  VERIFICAR PENDÊNCIAS
                </Button>
              </>
            ),
          ]}>
          <Table
            className="tabela-bidcycle"
            columns={columns}
            dataSource={data}
            rowKey={'id'}
            pagination={false}
            rowClassName={record => {
              return verificaErro(record.id) ? 'backgroundErro' : '';
            }}
            expandIcon={props => {
              const expanded = !props.record.children.length
                ? 'ant-table-row-spaced'
                : props.expanded
                ? 'ant-table-row-expanded'
                : 'ant-table-row-collapsed';
              return (
                <div
                  className={`ant-table-row-expand-icon ${expanded}`}
                  onClick={e => props.onExpand(props.record, e)}
                />
              );
            }}
          />
        </Widget>
        <ModalUpdateItem
          showModal={showModal}
          idPai={idPai}
          item={item}
          setShowModal={setShowModal}
          onUpdate={onUpdate}
          setItem={setItem}
          fluxoProcessoOptions={fluxoProcessoOptions}
        />
      </Panel>
    </Collapse>
  );
};
export default Parametros;
